import { WsLocationSearch, MapPinIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const LocationsFilter = ({
  name,
  title = 'Locations',
  wisestepApi = false,
  token = 'token',
  authorization = 'authorization',
  showAccordionIcon,
}: WsFilterProps) => (
  <WsAccordion title={title} startIcon={showAccordionIcon ? <MapPinIcon /> : null}>
    <WsLocationSearch
      size="small"
      placeHolder="Location"
      multiSelect={true}
      name={name}
      wisestepApi={wisestepApi}
      token={token}
      authorization={authorization}
    ></WsLocationSearch>
  </WsAccordion>
);

export default LocationsFilter;
